import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BROWSER_IS_WORKS } from '../browser';
import UnauthorizedScene from '../../__scenes__/unauthorized';
import { PageContext } from './contexts';
import './settings.css';

PageProvider.propTypes = {
  requires: PropTypes.array,
  language: PropTypes.oneOf(['en_US', 'ko_KR', 'ja_JP', 'zh_CN', 'zh_TW'])
    .isRequired,
  gnbBackgroundColor: PropTypes.string,
  gnbFontColor: PropTypes.string,
  menuDisplay: PropTypes.object,
  hasCampaignCodeBanner: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
export default function PageProvider({
  requires = [],
  language,
  gnbBackgroundColor,
  gnbFontColor,
  menuDisplay = {},
  hasCampaignCodeBanner = false,
  children,
}) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    Promise.all(requires).then(() => setReady(true));
  }, []);

  if (!ready) return null;
  return (
    <PageContext.Provider
      value={{
        language,
        gnbBackgroundColor,
        gnbFontColor,
        menuDisplay,
        hasCampaignCodeBanner,
      }}
    >
      <div
        className={classNames('wrap', language, {
          ua_win: navigator.platform.includes('Win'),
        })}
      >
        {BROWSER_IS_WORKS ? <UnauthorizedScene /> : children}
      </div>
    </PageContext.Provider>
  );
}
